import {
    takeEvery,
    call,
    all,
    put,
    fork,
} from 'redux-saga/effects';

import { types, actions } from './reducer';
import BrandService from '@iso/services/SettingsService/ProductService/BrandService';
import { extractError } from '@iso/lib/helpers/api';

function* submitBrand({ id, data }) {
    try {
        let response;
        if(id) {
            response = yield call(BrandService.editBrand, id, data);
        } else {
            response = yield call(BrandService.addBrand, data);
        }
        yield put(actions.submitBrandSucceeded(response.data));
    } catch (error) {
        yield put(actions.submitBrandFailed(extractError(error)));
    }
}

function* watchSubmitBrand() {
    yield takeEvery(
        types.REQUEST_SUBMIT_BRAND,
        submitBrand,
    );
}

function* createSaga() {
    yield all([
        fork(watchSubmitBrand),
    ]);
}

export default createSaga;